export default "__VITE_ASSET__ymUt52ok__"